const MAX_BODY_LENGTH = 500;

export default ({
  bodyText,
  statusCode,
}: {
  bodyText?: string;
  statusCode?: number;
}) => ({
  bodyText: (bodyText ?? '').slice(0, MAX_BODY_LENGTH),
  statusCode,
});
